import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
    const navigate = useNavigate();
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", 
      });
    };
  return (
    <Grid
      container
      sx={{
        marginTop: "10vh",
        backgroundColor: "#ece9e6",
        position: "relative",
        overflow: "hidden",
      }}
      id="contact"
    >
      {/* Decorative Shapes */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: "47%", md: "40%" },
          right: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "rotate(0deg)",
          zIndex: 1,
        }}
      >
        <img
          src="/shape.png"
          alt="Decorative Shape"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: { xs: "48%", md: "40%" },
          right: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transform: "rotate(180deg)",
          zIndex: 1,
        }}
      >
        <img
          src="/shape.png"
          alt="Decorative Shape"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Left Content */}
      <Grid item xs={12} sm={6} md={5}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
            padding: 3,
            flexDirection: "column",
            zIndex: 2,
            position: "relative",
          }}
        >
          <Typography
            variant="h4"
            sx={{
                fontWeight: "bold",
                marginBottom: 3,
                color: 'black',
    
                fontFamily: "Cursive",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                textAlign: "center",
            }}
          >
            Treten Sie mit uns in Kontakt
          </Typography>
         
          <Typography
            variant="body1"
            sx={{
              marginBottom: 3,
              color: "black",
              lineHeight: 1.8,
              fontSize: { xs: "1rem", sm: "1.1rem" },
            }}
          >
            Haben Sie Fragen oder möchten Sie einen Termin buchen? Kontaktieren Sie
            uns noch heute und lassen Sie uns gemeinsam die besten Lösungen für Ihre
            Anforderungen finden!
          </Typography>
          <Button
                    variant="contained"
                    onClick={() => {
                        navigate('/appointment');
                        scrollToTop();

                    }}

                    fullWidth
                    sx={{
                        alignSelf: "flex-start",
                        backgroundColor: "black",
                        "&:hover": {
                          backgroundColor: "#0277BD",
                        },
                        marginBottom: 2,
                      }}

                    
                  >
                    Termin buchen
                  </Button>

          <a href="tel:+4915901600845" style={{ textDecoration: "none" }}>
  <Button
                      variant="outlined"
    fullWidth
    sx={{
        alignSelf: "flex-start",
        color: "black",
        borderColor: "black",
        "&:hover": {
          borderColor: "#0277BD",
          backgroundColor: "#E3F2FD",
        },
        marginBottom: 2,

      }}
  >
    Kontaktieren Sie uns
  </Button>
</a>

                 
                </Box>
              </Grid>

              {/* Right Image */}
      <Grid item xs={12} sm={6} md={6}>
        <Box
          sx={{
            height: "100%",
            position: "relative",
            backgroundColor: "#ece9e6",
          }}
        >
          <img
            src="/Post.png"
            alt="ElektrotechnikEMN"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactUs;
